import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu/AppContainerWithMenu.component';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { clientPaths } from './paths';

const { Clients } = lazyImport(() => import('../views/clients'), 'Clients');
const { SSOConfiguration } = lazyImport(() => import('../views/ssoConfiguration'), 'SSOConfiguration');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const clientsRoutes: RouteObject[] = [
  {
    path: clientPaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <Clients /> },
      { path: clientPaths.sso.relative, element: <SSOConfiguration /> },
    ],
  },
];
